import { render, staticRenderFns } from "./confirmFeeDialog.vue?vue&type=template&id=f687628a&scoped=true"
import script from "./confirmFeeDialog.vue?vue&type=script&lang=js"
export * from "./confirmFeeDialog.vue?vue&type=script&lang=js"
import style0 from "./confirmFeeDialog.vue?vue&type=style&index=0&id=f687628a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f687628a",
  null
  
)

export default component.exports